(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', '../util/convert'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('../util/convert'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.convert);
    global.toggle = mod.exports;
  }
})(this, function (exports, _convert) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = exports.toggle = undefined;


  /**
   * Applies <code>!</code> to the property.
   * @function
   * @memberof lang
   * @param {Object} object The object to modify.
   * @param {Array|string} path The path of the property to set.
   * @return {Object} Returns the updated object.
   * @example toggle({ nested: { prop: true } }, 'nested.prop') // { nested: { prop: false } }
   * @since 0.1.5
   */
  var toggle = (0, _convert.convert)(function (v) {
    return !v;
  });
  exports.toggle = toggle;
  exports.default = toggle;
});